module.exports = __webpack_public_path__ + "static/media/li3.7ce955a0.jpg";